import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7f2b8f5a = () => interopDefault(import('../pages/health-check/index.vue' /* webpackChunkName: "pages/health-check/index" */))
const _8563650e = () => interopDefault(import('../pages/common/NotDefineComponentPage.vue' /* webpackChunkName: "pages/common/NotDefineComponentPage" */))
const _278227fc = () => interopDefault(import('../pages/company/CompanyDetailPage.vue' /* webpackChunkName: "pages/company/CompanyDetailPage" */))
const _0f4299cf = () => interopDefault(import('../pages/company/CompanyListPage.vue' /* webpackChunkName: "pages/company/CompanyListPage" */))
const _a96f9b02 = () => interopDefault(import('../pages/dashboard/DashboardPage.vue' /* webpackChunkName: "pages/dashboard/DashboardPage" */))
const _c0e9029a = () => interopDefault(import('../pages/enterprise/EnterpriseListPage.vue' /* webpackChunkName: "pages/enterprise/EnterpriseListPage" */))
const _4e55ba62 = () => interopDefault(import('../pages/manager/ManagerDetailPage.vue' /* webpackChunkName: "pages/manager/ManagerDetailPage" */))
const _b90cffa2 = () => interopDefault(import('../pages/manager/ManagerListPage.vue' /* webpackChunkName: "pages/manager/ManagerListPage" */))
const _beecbb1a = () => interopDefault(import('../pages/media-category/MediaCategoryDetailPage.vue' /* webpackChunkName: "pages/media-category/MediaCategoryDetailPage" */))
const _5a0b8f00 = () => interopDefault(import('../pages/media-category/MediaCategoryListPage.vue' /* webpackChunkName: "pages/media-category/MediaCategoryListPage" */))
const _112dde4d = () => interopDefault(import('../pages/media-company/MediaCompanyDetailPage.vue' /* webpackChunkName: "pages/media-company/MediaCompanyDetailPage" */))
const _034fa2da = () => interopDefault(import('../pages/media-company/MediaCompanyListPage.vue' /* webpackChunkName: "pages/media-company/MediaCompanyListPage" */))
const _01ae431d = () => interopDefault(import('../pages/media-journalist/MediaJournalistDetailPage.vue' /* webpackChunkName: "pages/media-journalist/MediaJournalistDetailPage" */))
const _2342fbaa = () => interopDefault(import('../pages/media-journalist/MediaJournalistListPage.vue' /* webpackChunkName: "pages/media-journalist/MediaJournalistListPage" */))
const _347aa8e6 = () => interopDefault(import('../pages/media-publish/MediaPublishDetailPage.vue' /* webpackChunkName: "pages/media-publish/MediaPublishDetailPage" */))
const _e30f5292 = () => interopDefault(import('../pages/media-publish/MediaPublishHistoryDetailPage.vue' /* webpackChunkName: "pages/media-publish/MediaPublishHistoryDetailPage" */))
const _95927fcc = () => interopDefault(import('../pages/media-publish/MediaPublishListPage.vue' /* webpackChunkName: "pages/media-publish/MediaPublishListPage" */))
const _617f032e = () => interopDefault(import('../pages/membership/login.vue' /* webpackChunkName: "pages/membership/login" */))
const _7e99ecf4 = () => interopDefault(import('../pages/monitoring/MonitoringDetailPage.vue' /* webpackChunkName: "pages/monitoring/MonitoringDetailPage" */))
const _16684853 = () => interopDefault(import('../pages/monitoring/MonitoringListPage.vue' /* webpackChunkName: "pages/monitoring/MonitoringListPage" */))
const _0412ae58 = () => interopDefault(import('../pages/permission/PermissionInfo.vue' /* webpackChunkName: "pages/permission/PermissionInfo" */))
const _194f3a40 = () => interopDefault(import('../pages/recommend/RecommendDetailPage.vue' /* webpackChunkName: "pages/recommend/RecommendDetailPage" */))
const _882540e6 = () => interopDefault(import('../pages/recommend/RecommendListPage.vue' /* webpackChunkName: "pages/recommend/RecommendListPage" */))
const _5d006449 = () => interopDefault(import('../pages/sample/code.vue' /* webpackChunkName: "pages/sample/code" */))
const _3d0430e1 = () => interopDefault(import('../pages/sample/date-picker.vue' /* webpackChunkName: "pages/sample/date-picker" */))
const _fc42f326 = () => interopDefault(import('../pages/sample/dropdown.vue' /* webpackChunkName: "pages/sample/dropdown" */))
const _22d0c8c4 = () => interopDefault(import('../pages/sample/input.vue' /* webpackChunkName: "pages/sample/input" */))
const _e1f2b5ce = () => interopDefault(import('../pages/sample/sampleDirective.vue' /* webpackChunkName: "pages/sample/sampleDirective" */))
const _1b81619a = () => interopDefault(import('../pages/sample/sampleUI.vue' /* webpackChunkName: "pages/sample/sampleUI" */))
const _ea90f260 = () => interopDefault(import('../pages/sample/sampleUITag.vue' /* webpackChunkName: "pages/sample/sampleUITag" */))
const _00f441be = () => interopDefault(import('../pages/sample/smapleUrl.vue' /* webpackChunkName: "pages/sample/smapleUrl" */))
const _6daf4889 = () => interopDefault(import('../pages/tag/TagListPage.vue' /* webpackChunkName: "pages/tag/TagListPage" */))
const _40cc9326 = () => interopDefault(import('../pages/user/UserDetailPage.vue' /* webpackChunkName: "pages/user/UserDetailPage" */))
const _6497b9f3 = () => interopDefault(import('../pages/user/UserListPage.vue' /* webpackChunkName: "pages/user/UserListPage" */))
const _6944e233 = () => interopDefault(import('../pages/withdrawal/WithdrawalListPage.vue' /* webpackChunkName: "pages/withdrawal/WithdrawalListPage" */))
const _5edad9ad = () => interopDefault(import('../pages/membership/password/find.vue' /* webpackChunkName: "pages/membership/password/find" */))
const _43c2d3ea = () => interopDefault(import('../pages/membership/password/reset.vue' /* webpackChunkName: "pages/membership/password/reset" */))
const _725b8c9e = () => interopDefault(import('../pages/membership/password/set.vue' /* webpackChunkName: "pages/membership/password/set" */))
const _33448529 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/health-check",
    component: _7f2b8f5a,
    name: "health-check"
  }, {
    path: "/common/NotDefineComponentPage",
    component: _8563650e,
    name: "common-NotDefineComponentPage"
  }, {
    path: "/company/CompanyDetailPage",
    component: _278227fc,
    name: "company-CompanyDetailPage"
  }, {
    path: "/company/CompanyListPage",
    component: _0f4299cf,
    name: "company-CompanyListPage"
  }, {
    path: "/dashboard/DashboardPage",
    component: _a96f9b02,
    name: "dashboard-DashboardPage"
  }, {
    path: "/enterprise/EnterpriseListPage",
    component: _c0e9029a,
    name: "enterprise-EnterpriseListPage"
  }, {
    path: "/manager/ManagerDetailPage",
    component: _4e55ba62,
    name: "manager-ManagerDetailPage"
  }, {
    path: "/manager/ManagerListPage",
    component: _b90cffa2,
    name: "manager-ManagerListPage"
  }, {
    path: "/media-category/MediaCategoryDetailPage",
    component: _beecbb1a,
    name: "media-category-MediaCategoryDetailPage"
  }, {
    path: "/media-category/MediaCategoryListPage",
    component: _5a0b8f00,
    name: "media-category-MediaCategoryListPage"
  }, {
    path: "/media-company/MediaCompanyDetailPage",
    component: _112dde4d,
    name: "media-company-MediaCompanyDetailPage"
  }, {
    path: "/media-company/MediaCompanyListPage",
    component: _034fa2da,
    name: "media-company-MediaCompanyListPage"
  }, {
    path: "/media-journalist/MediaJournalistDetailPage",
    component: _01ae431d,
    name: "media-journalist-MediaJournalistDetailPage"
  }, {
    path: "/media-journalist/MediaJournalistListPage",
    component: _2342fbaa,
    name: "media-journalist-MediaJournalistListPage"
  }, {
    path: "/media-publish/MediaPublishDetailPage",
    component: _347aa8e6,
    name: "media-publish-MediaPublishDetailPage"
  }, {
    path: "/media-publish/MediaPublishHistoryDetailPage",
    component: _e30f5292,
    name: "media-publish-MediaPublishHistoryDetailPage"
  }, {
    path: "/media-publish/MediaPublishListPage",
    component: _95927fcc,
    name: "media-publish-MediaPublishListPage"
  }, {
    path: "/membership/login",
    component: _617f032e,
    name: "membership-login"
  }, {
    path: "/monitoring/MonitoringDetailPage",
    component: _7e99ecf4,
    name: "monitoring-MonitoringDetailPage"
  }, {
    path: "/monitoring/MonitoringListPage",
    component: _16684853,
    name: "monitoring-MonitoringListPage"
  }, {
    path: "/permission/PermissionInfo",
    component: _0412ae58,
    name: "permission-PermissionInfo"
  }, {
    path: "/recommend/RecommendDetailPage",
    component: _194f3a40,
    name: "recommend-RecommendDetailPage"
  }, {
    path: "/recommend/RecommendListPage",
    component: _882540e6,
    name: "recommend-RecommendListPage"
  }, {
    path: "/sample/code",
    component: _5d006449,
    name: "sample-code"
  }, {
    path: "/sample/date-picker",
    component: _3d0430e1,
    name: "sample-date-picker"
  }, {
    path: "/sample/dropdown",
    component: _fc42f326,
    name: "sample-dropdown"
  }, {
    path: "/sample/input",
    component: _22d0c8c4,
    name: "sample-input"
  }, {
    path: "/sample/sampleDirective",
    component: _e1f2b5ce,
    name: "sample-sampleDirective"
  }, {
    path: "/sample/sampleUI",
    component: _1b81619a,
    name: "sample-sampleUI"
  }, {
    path: "/sample/sampleUITag",
    component: _ea90f260,
    name: "sample-sampleUITag"
  }, {
    path: "/sample/smapleUrl",
    component: _00f441be,
    name: "sample-smapleUrl"
  }, {
    path: "/tag/TagListPage",
    component: _6daf4889,
    name: "tag-TagListPage"
  }, {
    path: "/user/UserDetailPage",
    component: _40cc9326,
    name: "user-UserDetailPage"
  }, {
    path: "/user/UserListPage",
    component: _6497b9f3,
    name: "user-UserListPage"
  }, {
    path: "/withdrawal/WithdrawalListPage",
    component: _6944e233,
    name: "withdrawal-WithdrawalListPage"
  }, {
    path: "/membership/password/find",
    component: _5edad9ad,
    name: "membership-password-find"
  }, {
    path: "/membership/password/reset",
    component: _43c2d3ea,
    name: "membership-password-reset"
  }, {
    path: "/membership/password/set",
    component: _725b8c9e,
    name: "membership-password-set"
  }, {
    path: "/",
    component: _33448529,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
